export const STORE_USER_INFO =  'storeUserInfo'
export const LOCAL_USER_INFO =  'localUserInfo'
export const TOKEN_ID = 'token'
export const LOCAL_ROLE_ID = 'localRoleId'


// WEBPACK FOOTER //
// ./src/mutation/mutConst.js